<script setup lang="ts">
import { Close, FullScreen, Minus, Refresh } from '@element-plus/icons-vue';

defineProps<{ pageTitle: string; showRefresh?: boolean }>();
const emit = defineEmits<{ refresh: [] }>();

const bridge = () => window.electron ?? window.api ?? window.electronAPI;

function minimize() { void bridge()?.minimizeWindow(); }
function toggleMaximize() { void bridge()?.toggleMaximizeWindow(); }
function close() { void bridge()?.closeWindow(); }
</script>

<template>
  <header class="topbar">
    <img class="topbar__wordmark" src="@/assets/logo-wordmark.png" alt="罗根智能体" />
    <span class="topbar__page">{{ pageTitle }}</span>

    <div class="topbar__right">
      <button v-if="showRefresh" class="topbar__btn" type="button" title="刷新" @click="emit('refresh')">
        <el-icon :size="13"><Refresh /></el-icon>
      </button>
      <button class="topbar__btn" type="button" title="最小化" @click="minimize">
        <el-icon :size="13"><Minus /></el-icon>
      </button>
      <button class="topbar__btn" type="button" title="全屏" @click="toggleMaximize">
        <el-icon :size="13"><FullScreen /></el-icon>
      </button>
      <button class="topbar__btn topbar__btn--close" type="button" title="关闭" @click="close">
        <el-icon :size="13"><Close /></el-icon>
      </button>
    </div>
  </header>
</template>

<style scoped>
/* 真实产品：顶部不是导航栏，只是「字标 + 页面名 + 窗口控制」悬浮一条 */
.topbar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  gap: 22px;
  height: 56px;
  padding: 0 20px;
  pointer-events: none;
  -webkit-app-region: drag;
}

.topbar > * {
  pointer-events: auto;
}

.topbar__wordmark {
  width: 128px;
  height: auto;
  object-fit: contain;
  -webkit-user-drag: none;
}

.topbar__page {
  color: var(--lg-color-text-secondary);
  font-size: 13px;
}

.topbar__right {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: auto;
  color: var(--lg-color-text-muted);
}

.topbar__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: 0;
  border-radius: var(--lg-radius-sm);
  background: transparent;
  color: inherit;
  cursor: pointer;
  -webkit-app-region: no-drag;
}

.topbar__btn:hover {
  background: var(--lg-color-surface-hover);
  color: var(--lg-color-text-primary);
}

.topbar__btn--close:hover {
  background: #e5484d;
  color: #fff;
}
</style>
